export default "__VITE_ASSET__BymYrvlu__"